import type { PresentationModule } from '../../presentation/types';
import { native } from './content';
import { NativeScene } from './scenes/NativeScene';

/** Moderta Native: its own brand and section, immediately after Research Space. */
export const nativeModule: PresentationModule = {
  id: 'native',
  label: 'Moderta Native',
  priority: 'major',
  scenes: [
    { ...native, module: 'native', create: (resolved) => new NativeScene(resolved) },
  ],
};
